import React from 'react';
import { TChildren } from '../../typings/common';
import styles from './Toast.module.scss';
import Icon, { IconGlyph } from '../Icon';
import { Phrases } from '../../utilities/constants/phrases';
import useTimeout from '../../hooks/useTimeout';

const TOAST_DURATION = 5000;

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
}

interface Props {
  children: TChildren;
  close: () => void;
  type?: ToastType;
  duration?: number;
}

const Toast: React.FC<Props> = ({
  children,
  close,
  type = ToastType.SUCCESS,
  duration = TOAST_DURATION,
}) => {
  useTimeout(close, duration);

  const isError = type === ToastType.ERROR;
  const iconGlyph = isError ? IconGlyph.TOAST_ERROR : IconGlyph.SUCCESS_FILLED;
  const toastClassName = isError
    ? `${styles.toast} ${styles.toastError}`
    : styles.toast;

  return (
    <div className={toastClassName}>
      <div className={styles.content}>
        <div>
          <Icon glyph={iconGlyph} />
        </div>
        <div className={styles.text}>{children}</div>
      </div>
      <div>
        <button
          type='button'
          onClick={close}
          className={styles.closeButton}
          aria-label={Phrases.TOAST_CLOSE_BUTTON_LABEL}>
          <Icon glyph={IconGlyph.CLOSE} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
